import { Injectable, EventEmitter } from '@angular/core';

import * as Rx from "rxjs/Rx";
import { Utils } from './utils';
import { escapeRegExp } from 'tslint/lib/utils';
import { environment } from '../../environments/environment';
import { UserUtil } from './user-util';
import { SessionAnuglarService } from './session-anuglar.service';

@Injectable()
export class WebsocketService {

  public closeEvent = new EventEmitter<any>();
  public mudaStatusServer = new EventEmitter<boolean>();

  constructor() { }
  private subject: Rx.Subject<MessageEvent>;
  private ws: WebSocket;
  private _status = false;
  private url = environment.websocketURL;
  private ticks;
  public mensagem = new EventEmitter<any>();

  public get status(){
    return this._status;
  }

  public get event() {
    return this.subject;
  }

  public close() {
    if (this.ws) {
      if (this.subject) {
        this.subject.unsubscribe();
      }
      this.subject = null;
      this.ws.close();
    }
    if (this.ticks) {
      clearInterval(this.ticks);
      this.ticks = null;
    }
    this._status = false;
    this.mudaStatusServer.emit(false);
  }

  public connect(usuario): Rx.Subject<MessageEvent> {
    if (!this.subject) {
      let lurl = '';
      if (!environment.relativeURL) {
        lurl = this.url + '/cad' + escapeRegExp(usuario);
      } else {
        const ssl = window.location.protocol === 'https:';
        if (ssl) {
          lurl = 'wss://';
          lurl += window.location.hostname + ':' + environment.wsPort + this.url + '/cad' + escapeRegExp(usuario);
        } else {
          lurl = 'ws://';
          lurl += window.location.hostname + ':' + environment.wsPort + this.url + '/cad' + escapeRegExp(usuario);
        }
      }
      this.subject = this.create(lurl);
    }
    if (this.subject) {
      this.subject.subscribe({
        next: (msg) => {
          let self = this;
          this.mensagem.emit(msg.data);
          if (!this.ticks) {
            this.ticks = setInterval(ticks => {
              if (!SessionAnuglarService.isLoggedIn()) {
                this.close();
              }
              this.enviarMensagem('PING' + (new Date().getTime()));
            }, 20000);
          }
          this._status = true;
          this.mudaStatusServer.emit(true);
        },
        complete: () => {
          this._status = false;
          this.mudaStatusServer.emit(false);
          this.closeEvent.emit(true);
          this.close();
        },
        error: () => {
          this._status = false;
          this.mudaStatusServer.emit(false);
          this.closeEvent.emit(true);
          this.close();
        }
      });
    }
    return this.subject;
  }

  public enviarMensagem(msg: string) {

    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(msg);
    }

  }

  private create(url): Rx.Subject<MessageEvent> {
    this.ws = new WebSocket(url);

    let observable = Rx.Observable.create((obs: Rx.Observer<MessageEvent>) => {
      this.ws.onmessage = obs.next.bind(obs);
      this.ws.onerror = obs.error.bind(obs);
      this.ws.onclose = obs.complete.bind(obs);
      return this.ws.close.bind(this.ws);
    });
    let observer = {
      next: (data: Object) => {
        if (this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify(data));
        }
      }
    };
    return Rx.Subject.create(observer, observable);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/websocket-service.service.ts